import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaTrashAlt } from "react-icons/fa";
import "../App.css";

const TipoComprobante = () => {
  const navigate = useNavigate();
  
  const [comprobante, setComprobante] = useState("");
  const [tipoFactura, setTipoFactura] = useState("");
  const [tipoDocumento] = useState("Artículos"); // ← valor fijo, no editable
  //const [tipoDocumento, setTipoDocumento] = useState("");
  const [poseeOrdenCompra, setPoseeOrdenCompra] = useState(false);
  const [poseeEntrega, setPoseeEntrega] = useState(false);
  const [ordenCompra, setOrdenCompra] = useState([""]);
  const [numeroEntrega, setNumeroEntrega] = useState([""]);

  const [errores, setErrores] = useState({});

  // Manejar cambio en un input
  const handleChangeArray = (setter, values, index, newValue) => {
    const updated = [...values];
    updated[index] = newValue;
    setter(updated);
  };

  // Agregar un nuevo input vacío
  const handleAddField = (setter, values) => {
    setter([...values, ""]);
  };

  // Eliminar un input específico
  const handleRemoveField = (setter, values, index) => {
    const updated = values.filter((_, i) => i !== index);
    setter(updated.length > 0 ? updated : [""]); // aseguramos que quede al menos uno
  };


  const mapComprobante = {
    Factura: "FAC",
    "Nota de Débito": "ND",
    "Nota de Crédito": "NC",
  };

  const handleComprobanteClick = (tipo) => {
    setComprobante(tipo);
    if (tipo !== "Factura") {
      setTipoFactura("");
    }
  };

  const validar = () => {
    const nuevosErrores = {};
  
    if (!comprobante) nuevosErrores.comprobante = "Campo obligatorio";
    if (comprobante === "Factura" && !tipoFactura) nuevosErrores.tipoFactura = "Campo obligatorio";
    //if (!tipoDocumento) nuevosErrores.tipoDocumento = "Campo obligatorio";
  
    // Validar si activó el switch de Orden de Compra y no puso nada
    if (poseeOrdenCompra && ordenCompra.every(val => !val)) nuevosErrores.ordenCompra = "Campo obligatorio";
  
    // Validar si activó el switch de Número de Entrega y no puso nada
    if (poseeEntrega && numeroEntrega.every(val => !val)) nuevosErrores.numeroEntrega = "Campo obligatorio";
  
    // Validar que al menos uno esté completo
    if (!poseeOrdenCompra && !poseeEntrega) nuevosErrores.ordenGeneral = "Debe completar al menos uno";
  
    setErrores(nuevosErrores);
    return Object.keys(nuevosErrores).length === 0;
  };
  
  const handleNext = async () => {
    const nuevosErrores = {};
  
    if (!comprobante) nuevosErrores.comprobante = true;
    if (comprobante === "Factura" && !tipoFactura) nuevosErrores.tipoFactura = true;
    if (!tipoDocumento) nuevosErrores.tipoDocumento = true;
  
    // ✅ Verificación correcta
    if (poseeOrdenCompra && !ordenCompra) {
      nuevosErrores.ordenCompra = true;
    }
    if (poseeEntrega && !numeroEntrega) {
      nuevosErrores.numeroEntrega = true;
    }
    if (!poseeOrdenCompra && !poseeEntrega) {
      nuevosErrores.ordenGeneral = true; // Ambos switches apagados
    }
  
    setErrores(nuevosErrores);
  
    if (Object.keys(nuevosErrores).length > 0) {
      alert("❗ Debe completar todos los campos obligatorios.");
      return;
    }
  
    const tipoComprobanteFinal = mapComprobante[comprobante] || "";
  
    localStorage.setItem(
      "tipoComprobante",
      JSON.stringify({
        comprobante: tipoComprobanteFinal,
        tipoFactura,
        tipoDocumento,
        ordenCompra: ordenCompra.filter(val => val).join(";"),   // concatenado con ;
        numeroEntrega: numeroEntrega.filter(val => val).join(";"), // concatenado con ;
      })
    );

    //try {
      //await fetch("http://localhost:5000/api/saveTipoComprobante", {
        //method: "POST",
        //headers: { "Content-Type": "application/json" },
        //body: JSON.stringify({
          //tipoComprobante: tipoComprobanteFinal,
          //tipoFactura,
          //tipoDocumento,
          //ordenCompra,
          //numeroEntrega,
        //}),
      //});
  
      navigate("/percepciones");
    //} catch (error) {
      //console.error("Error al guardar en Google Sheets:", error);
      //alert("Hubo un error al guardar los datos.");
    //}
  };
  
  return (
    <div className="comprobante-form">
      <h3 className="comprobante-title">Seleccionar Tipo de Comprobante</h3>

      {/* Botones de selección de Comprobante */}
      <div className="comprobante-buttons">
        {["Factura", "Nota de Débito", "Nota de Crédito"].map((tipo) => (
          <button
            key={tipo}
            className={comprobante === tipo ? "selected" : "default"}
            onClick={() => handleComprobanteClick(tipo)}
          >
            {tipo}
          </button>
        ))}
      </div>

      {/* Desplegable tipo de factura (solo si Factura) */}
      {comprobante === "Factura" && (
        <select
          className={`input-field-comprobante ${errores.tipoFactura ? "error" : ""}`}
          value={tipoFactura}
          onChange={(e) => setTipoFactura(e.target.value)}
        >
          <option value="">Seleccione tipo de Factura</option>
          <option value="A">A</option>
          <option value="B">B</option>
          <option value="C">C</option>
        </select>
      )}

      {/* Tipo de Documento 
      <select
        className={`input-field-comprobante ${errores.tipoDocumento ? "error" : ""}`}
        value={tipoDocumento}
        onChange={(e) => setTipoDocumento(e.target.value)}
      >
        <option value="">Seleccione Tipo de Documento</option>
        <option value="Servicio">Servicio</option>
        <option value="Artículos">Artículos</option>
      </select>*/}

      {/* Switch Posee Orden de Compra */}
      <div className="switch-container">
        <label className="switch-label">¿Posee Número de Orden de Compra?</label>
        <label className="switch">
            <input
            type="checkbox"
            checked={poseeOrdenCompra}
            onChange={(e) => setPoseeOrdenCompra(e.target.checked)}
            />
            <span className="slider"></span>
        </label>
        </div>

        {poseeOrdenCompra && (
        <div className="multi-input-container">
          <label className="switch-label">Si la factura posee mas de un Número de Orden de Compra, por favor agregarlos</label>
          {ordenCompra.map((oc, index) => (
            <div key={index} className="multi-input-row">
              <input
                type="text"
                placeholder="Ingrese Número de Orden de Compra"
                className={`input-field-comprobante ${errores.ordenCompra || errores.ordenGeneral ? "error" : ""}`}
                value={oc}
                onChange={(e) => handleChangeArray(setOrdenCompra, ordenCompra, index, e.target.value)}
              />
              {ordenCompra.length > 1 && (
                <button
                  type="button"
                  className="delete-button"
                  onClick={() => handleRemoveField(setOrdenCompra, ordenCompra, index)}
                ><FaTrashAlt /></button>
              )}
            </div>
          ))}
          <button
            type="button"
            className="add-button"
            onClick={() => handleAddField(setOrdenCompra, ordenCompra)}
          >+ Agregar Orden de Compra</button>
        </div>
      )}

      {/* Switch Posee Número de Entrega */}
      <div className="switch-container">
        <label className="switch-label">¿Posee Número de Entrega?</label>
        <label className="switch">
            <input
            type="checkbox"
            checked={poseeEntrega}
            onChange={(e) => setPoseeEntrega(e.target.checked)}
            />
            <span className="slider"></span>
        </label>
      </div>

      {poseeEntrega && (
        <div className="multi-input-container">
          <label className="switch-label">Si la factura posee mas de un Número de Entrega, por favor agregarlos</label>
          {numeroEntrega.map((ne, index) => (
            <div key={index} className="multi-input-row">
              <input
                type="text"
                placeholder="Ingrese Número de Entrega"
                className={`input-field-comprobante ${errores.numeroEntrega || errores.ordenGeneral ? "error" : ""}`}
                value={ne}
                onChange={(e) => handleChangeArray(setNumeroEntrega, numeroEntrega, index, e.target.value)}
              />
              {numeroEntrega.length > 1 && (
                <button
                  type="button"
                  className="delete-button"
                  onClick={() => handleRemoveField(setNumeroEntrega, numeroEntrega, index)}
                ><FaTrashAlt /></button>
              )}
            </div>
          ))}
          <button
            type="button"
            className="add-button"
            onClick={() => handleAddField(setNumeroEntrega, numeroEntrega)}
          >+ Agregar Entrega</button>
        </div>
      )}

      <div className="button-container">
        <button className="primary-button" onClick={handleNext}>
          Siguiente
        </button>
      </div>
    </div>
  );
};

export default TipoComprobante;


